<article>
  <header>
    <div class="row">
      <div class="col">
        <h2 mat-dialog-title>Calendar User Configurations</h2>
      </div>
    </div>
  </header>
  <mat-dialog-content
    *ngIf="calendarConfigurationFacade.calendarConfigurationForm$ | async as formState"
  >
    <div class="content-padding">
      <div class="settings-header">GENERAL</div>
      <mat-radio-group [ngrxFormControlState]="formState.controls.calendarViewTypeId">
        View Upon Launch:
        <!-- TODO reenable 24Hr Calendar -->
        <mat-radio-button [value]="calendarViewType.Day" *ngIf="show24Hrs">24Hrs</mat-radio-button>
        <mat-radio-button [value]="calendarViewType.Week">Week</mat-radio-button>
        <mat-radio-button [value]="calendarViewType.Month">Month</mat-radio-button>
        <mat-radio-button [value]="calendarViewType.Staff">Staff</mat-radio-button>
      </mat-radio-group>
      <div class="additional-monthly">
        <mat-radio-group [ngrxFormControlState]="formState.controls.isAutoRefresh">
          Auto Refresh:
          <mat-radio-button [value]="true">On</mat-radio-button>
          <mat-radio-button [value]="false">Off</mat-radio-button>
        </mat-radio-group>
        <mat-select
          [ngrxFormControlState]="formState.controls.autoRefreshTimeInMinutes"
          placeholder="Auto Refresh Time Period"
          *ngIf="formState.controls.isAutoRefresh.value == true"
        >
          <mat-option [value]="5">Every 5 Minutes</mat-option>
          <mat-option [value]="10">Every 10 Minutes</mat-option>
          <mat-option [value]="15">Every 15 Minutes</mat-option>
        </mat-select>
      </div>
    </div>

    <div class="darker-background">
      <div class="content-padding">
        <div class="settings-header">MONTH VIEW</div>
        <mat-radio-group [ngrxFormControlState]="formState.controls.monthlyRibbonTypeId">
          Trip Display:
          <mat-radio-button [value]="monthlyCalendarRibbonType.Trip" id="trip-view-radio">
            Single Ribbon
          </mat-radio-button>
          <mat-radio-button [value]="monthlyCalendarRibbonType.Leg" id="leg-view-radio">
            Individual Legs
          </mat-radio-button>
        </mat-radio-group>
        <div class="additional-monthly">
          Additional Data Points:
          <mat-checkbox [ngrxFormControlState]="formState.controls.monthlyShowPilotInitials">
            Pilot Initials
          </mat-checkbox>
          <mat-checkbox [ngrxFormControlState]="formState.controls.monthlyShowPaxCount">
            Pax Count
          </mat-checkbox>
          <mat-checkbox
            [ngrxFormControlState]="formState.controls.monthlyShowAircraftLastKnownLocation"
          >
            Aircraft Last Known Location
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="darker-background">
      <div class="content-padding">
        <div class="settings-header">WEEK VIEW</div>
        <div class="additional-monthly">
          View Upon Launch:
          <mat-checkbox [ngrxFormControlState]="formState.controls.weekShowTails">
            Tails
          </mat-checkbox>
          <mat-checkbox [ngrxFormControlState]="formState.controls.weekShowStaff">
            Staff
          </mat-checkbox>
        </div>
        <div class="error-message" *ngIf="formState.errors?.weekViewRequired">
          {{ formState.errors.weekViewRequired.message }}
        </div>
      </div>
    </div>
    <div class="darker-background">
      <div class="content-padding">
        <div class="settings-header">STAFF VIEW</div>
        <mat-radio-group [ngrxFormControlState]="formState.controls.staffViewTypeId">
          Ribbon Display:
          <mat-radio-button [value]="staffViewType.AirportCode" id="tail-number-radio">
            Tail Number
          </mat-radio-button>
          <mat-radio-button [value]="staffViewType.TailNumber" id="airport-code-radio">
            Airport Code
          </mat-radio-button>
        </mat-radio-group>
        <div class="additional-monthly view-upon-launch-row">
          <span class="view-upon-launch-group">
            View Upon Launch:
            <mat-checkbox [ngrxFormControlState]="formState.controls.staffShowTails">
              Tails
            </mat-checkbox>
            <mat-checkbox [ngrxFormControlState]="formState.controls.staffShowStaff">
              Staff
            </mat-checkbox>
          </span>
          <span class="optional-group">
            Optional:
            <mat-checkbox [ngrxFormControlState]="formState.controls.staffShowMetrics">
              Metrics
            </mat-checkbox>
          </span>
        </div>
        <div class="error-message" *ngIf="formState.errors?.staffViewRequired">
          {{ formState.errors.staffViewRequired.message }}
        </div>
      </div>
    </div>
    <div class="darker-background">
      <div class="content-padding">
        <div class="settings-header">SCHEDULE A TRIP</div>
        <mat-radio-group [ngrxFormControlState]="formState.controls.buildTripViewTypeId">
          View Default:
          <mat-radio-button [value]="buildTripViewType.Vertical"> Vertical </mat-radio-button>
          <mat-radio-button [value]="buildTripViewType.ByLeg"> By Leg </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="justify-content-end"
    *ngIf="calendarConfigurationFacade.calendarConfigurationForm$ | async as formState"
  >
    <div class="row">
      <div class="col">
        <button
          mat-button
          close
          type="button"
          [mat-dialog-close]="false"
          (click)="calendarConfigurationFacade.cancelChanges()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          id="calendar-config-modal-save-btn"
          close
          mat-raised-button
          color="primary"
          type="submit"
          [mat-dialog-close]
          [disabled]="
            (calendarConfigurationFacade.isFormUnchanged$ | async) ||
            formState.isInvalid ||
            (formState.controls.isAutoRefresh.value &&
            formState.controls.autoRefreshTimeInMinutes.value == 0)
          "
          (click)="calendarConfigurationFacade.confirmChanges()"
        >
          Save
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</article>
